// extracted by mini-css-extract-plugin
export default {"outerContainer":"BEX9Q","container":"xoNRi","searchText":"QzT3Q","header":"Nl-wV","schoolSearchContainer":"K7YqB","noResultsInfo":"x8-Ce"};